// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"dfc5a3b8","453":"d0bcacf9"}[chunkId] + ".chunk.js";
};